function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import cx from "classnames";
import { classPrefix } from "./index";
var EmptyNode = function EmptyNode() {
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-empty")
  }, "\u6682\u65E0\u6570\u636E");
};
var ColumnsNode = function ColumnsNode(props) {
  var dataSourceKey = props.dataSourceKey,
    dataSource = props.dataSource,
    columnsList = props.columnsList,
    columnProps = props.columnProps,
    tbodyClass = props.tbodyClass;
  if (dataSource.length === 0) return /*#__PURE__*/React.createElement(EmptyNode, null);
  return /*#__PURE__*/React.createElement("tbody", {
    className: tbodyClass
  }, dataSource.map(function (source) {
    var key = source[dataSourceKey || "key"] || Object.keys(source)[0];
    var renderedColumns = [];
    var colspanRecord = 1;
    columnsList.forEach(function (columnKey, index) {
      var getProps = columnProps[columnKey];
      var currColspan = getProps.rowColspan || 1;
      if (colspanRecord === 1) {
        renderedColumns.push(/*#__PURE__*/React.createElement("td", {
          colSpan: currColspan,
          key: columnKey,
          style: {
            padding: getProps.padding,
            textAlign: getProps.align
          },
          className: cx(_defineProperty({}, "".concat(classPrefix, "-separate"), getProps.separate))
        }, getProps.render(source[columnKey], source, index)));
        if (currColspan > 1) {
          colspanRecord = currColspan;
        }
      } else {
        colspanRecord = colspanRecord - 1;
      }
    });
    return /*#__PURE__*/React.createElement("tr", {
      key: key
    }, renderedColumns);
  }));
};
export default ColumnsNode;